import * as React from 'react';
export const TableBody = ({ as = 'tbody', ...rest }) => {
    return React.createElement(as, {
        role: as !== 'tbody' ? 'rowgroup' : undefined,
        ...rest,
    });
};
